import * as React from 'react';
import { FormControlHelpers } from '../../formcontrols/helpers/FormControlHelpers';
import ReactHtmlParser from 'react-html-parser';
import { StringHelpers } from '../../helpers/StringHelpers';

export interface IGridColumnDetailsProps {
  data: any;
  title: string;
  dataType: string;
  currencyFormat: string;
  decimalSeparator: string;
  url: string;
}

export const GridColumnDetails = (props: IGridColumnDetailsProps) => {
  let data = props.data;

  if (props.dataType !== undefined && props.dataType !== "") {

    if (props.url) {
      data = StringHelpers.replacePropertiesInUrl(props.url, props, true);
    } else {
      data = FormControlHelpers.convertValueToType(data, {
        dataType: props.dataType,
        decimalSeparator: props.decimalSeparator,
        currencyFormat: props.currencyFormat
      });
    }
  }

  data = ReactHtmlParser(data ? FormControlHelpers.replaceTaggedEmailAddressesWithoutTags(data) : "-");

  return <div
    className="mijn-fnv-grid__detail-row">
    <span className="mijn-fnv-grid__detail-label">{props.title}</span>
    <span className="mijn-fnv-grid__detail-data">{data}</span>
  </div>;
};